import React from "react";

import Info from "./Info";

import EditCard from "uicomponents/EditCard";

import { sectionsQuestions } from "pages/WorkersCompApplcation/utils/sectionsQuestions";
import { OfficeLocationList, SingleBusinessAddressType } from "types";

import styles from "../ReviewAndSubmit.module.css";

interface IOfficeLocationReviewProps {
  data: OfficeLocationList;
  setActiveStepIndex: (index: number) => void;
  sectionNumber: number;
}

type TDataEntries = [keyof SingleBusinessAddressType, string];

const OfficeLocationReview = ({
  data,
  setActiveStepIndex,
  sectionNumber,
}: IOfficeLocationReviewProps): JSX.Element => {
  if (!data) {
    return <></>;
  }

  const sortedOfficeLocations = data?.sort((a, b) => (a.isHq ? -1 : 1));
  const questions = Object.entries(
    sectionsQuestions.officeLocation.questions
  ) as TDataEntries[];

  return (
    <EditCard
      title={`${sectionsQuestions.officeLocation.title}`}
      onEditClick={() => setActiveStepIndex(sectionNumber)}
    >
      {sortedOfficeLocations.map((officeLocation, index) => {
        return (
          <React.Fragment key={officeLocation.uuid}>
            <span className={styles.subsectionTitle}>
              {index + 1}:{" "}
              {officeLocation?.isHq
                ? sectionsQuestions.officeLocation.editCardTitlePrimary
                : sectionsQuestions.officeLocation.editCardTitleOther}
            </span>

            {questions.map(([key, value]) => {
              return (
                <Info
                  key={key}
                  question={value}
                  answer={officeLocation[key] ?? ""}
                  questionFieldName={key}
                />
              );
            })}
          </React.Fragment>
        );
      })}
    </EditCard>
  );
};

export default OfficeLocationReview;
